import { getUseServiceWithSubscriptionKeys } from '../utils';
import { configService } from './service';

export const useConfigWithKeys = getUseServiceWithSubscriptionKeys(configService);
